var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-default btn-call full-width",attrs:{"href":'tel:003228281450'}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v("\n    "+_vm._s(_vm._f("trans")('Call Bureau'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }